import { httpResource } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { ConsensusExportListItem } from '@api-response-types/consensus-export.response';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';
import { selectSelectedConsensusTemplateId } from 'demand-forecasting/store/router-state/router.selectors';

/**
 * State holder for the consensus download centre (Step I). Mirrors
 * `AnalysisStateService.exports` — an `httpResource` keyed by the currently
 * selected `consensusTemplateId` route param. The SSE handler calls
 * `.reload()` on every consensus-export event so the LIST tab stays live.
 */
@Injectable({ providedIn: 'root' })
export class ConsensusExportStateService {
  private readonly store = inject(Store);

  private readonly consensusTemplateId = this.store.selectSignal(
    selectSelectedConsensusTemplateId,
  );

  public exports = httpResource<ConsensusExportListItem[]>(() => {
    const consensusTemplateId = this.consensusTemplateId();
    if (!consensusTemplateId) {
      return undefined;
    }
    return `${environment.api.url}/consensus/exports?consensusTemplateId=${consensusTemplateId}`;
  });

  /**
   * Set by the SSE handler when an export reaches COMPLETED; consumed (and
   * cleared) by an open export dialog to auto-select the finished row for
   * one-click download. One-shot trigger.
   */
  public readonly lastCompletedExportId = signal<string | undefined>(undefined);
}
